import React, { useEffect, useState, useMemo } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useErrorHandler } from "../../../hooks";

import metadataService from "../../../services/metaData.service";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function SpecialSettingPage() {

    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        let newData = data.filter(it => item.id != it.id)
        await metadataService.setMetaData("special", newData);
        onRefresh()
    };

    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "عنوان",
                mainField: false,
            },
            {
                field: "href",
                title: "لینک",
                mainField: false,
            },
        ],
        []
    );

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await metadataService.getMetaData("special");
        if (error) {
            return;
        }
        setData(data.special.map((item, index) => ({...item, id: index+1})) || []);
    };

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                order={{ order: "ASC", orderBy: "index" }}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent allSpecials={data} {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.title}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد ویژه",
                        modalContent: (props) => <FormModalContent allSpecials={data} {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="مدیریت لیست های ویژه"
            />
        </div>
    );
}
